(function() {
  "use strict";

  function FilterShippingCtrl($scope, $state, mdPanelRef) {
    var panelRef = mdPanelRef;
    var ctrl = this;
    ctrl.radioData = [
      { label: "Frete Mandaê", value: "MandaeNormal", checked: false },
      { label: "Rápido", value: "MandaeExpress", checked: false },
      { label: "Econômico", value: "MandaeEconomico", checked: false },
      { label: "Sem serviço de envio", value: "notFound", checked: false }
    ];

    if (ctrl.currentFilter) {
      var index = ctrl.currentFilter.indexOf(null);
      if (index !== -1) {
        ctrl.currentFilter[index] = "notFound";
      }

      _.filter(ctrl.radioData, element => {
        return ctrl.currentFilter.includes(element.value)
          ? (element.checked = true)
          : (element.checked = false);
      });
    }

    ctrl.closeMenu = function(form, action) {
      var filterList = [];
      for (var i = 0; i < ctrl.radioData.length; i++) {
        if (ctrl.radioData[i].checked) {
          filterList.push(ctrl.radioData[i].value);
        }
      }

      if (!panelRef) {
        return;
      }
      panelRef
        .close({
          action: action,
          filter: filterList
        })
        .then(function() {
          panelRef.destroy();
        });
    };
  }

  angular
    .module("mandaeApp")
    .controller("FilterShippingCtrl", FilterShippingCtrl);
})();
